export enum GoogleAnalyticsEscriptEventName {
  PRESCRIPTION_SUBMIT_ATTEMPT = 'dle_prescription_submit_attempt', // submit token
  PRESCRIPTION_SUBMIT_COMPLETE = 'dle_prescription_submit_complete', // submit token
  PRESCRIPTION_SUBMIT_VERIFIED = 'dle_prescription_submit_verified', // login hit with onboard key
  ACCOUNT_REGISTRATION_COMPLETE = 'dle_account_registration_complete', // login hit and signed up
  ORDER_INITIATED = 'dle_order_initiated', // start of order flow
  ORDER_CHECKOUT_START = 'dle_order_checkout_start', // pharmacy allocation
  PRESCRIPTION_SUBMIT_ERROR = 'dle_prescription_submit_error', // add new script
  PRESCRIPTION_SUBMIT_ALREADY_ATTACHED = 'dle_prescription_submit_already_attached', // onboarding duplicate script
}
